import { render, staticRenderFns } from "./TermsAMAZSD106IPGSummerInstitute2022.vue?vue&type=template&id=2328df25"
import script from "./TermsAMAZSD106IPGSummerInstitute2022.vue?vue&type=script&lang=js"
export * from "./TermsAMAZSD106IPGSummerInstitute2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports